import { render } from "./QuotedDetail.vue?vue&type=template&id=571de27b&scoped=true&ts=true&lang=pug"
import script from "./QuotedDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuotedDetail.vue?vue&type=script&lang=ts&setup=true"

import "./QuotedDetail.vue?vue&type=style&index=0&id=571de27b&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571de27b"]])

export default __exports__